import { useState, useCallback } from "react";

export const useModalManager = () => {
  const [modalState, setModalState] = useState({
    mobile: false,
    bank: false,
    wallet: false,
  });

  const openModal = useCallback((modalType) => {
    setModalState((prev) => ({ ...prev, [modalType]: true }));
  }, []);

  const closeModal = useCallback((modalType) => {
    setModalState((prev) => ({ ...prev, [modalType]: false }));
  }, []);

  const closeAllModals = useCallback(() => {
    setModalState({
      mobile: false,
      bank: false,
      wallet: false,
    });
  }, []);

  const isModalOpen = useCallback(
    (modalType) => {
      return modalState[modalType];
    },
    [modalState],
  );

  return {
    modalState,
    openModal,
    closeModal,
    closeAllModals,
    isModalOpen,
  };
};

export default useModalManager;
